import { useQuery } from '@tanstack/react-query';
import type { AuditLogEntry, AuditLogQuery } from '@accounting/shared';
import { api } from '../lib/api';

export function useAuditLog(companyId: string | null, filters: AuditLogQuery) {
  return useQuery({
    queryKey: ['audit-log', companyId ?? 'none', filters],
    enabled: companyId !== null,
    queryFn: () => {
      const params: Record<string, string> = {};
      if (filters.entityType) params.entityType = filters.entityType;
      if (filters.action) params.action = filters.action;
      if (filters.from) params.from = filters.from;
      if (filters.to) params.to = filters.to;
      if (filters.limit) params.limit = String(filters.limit);
      return api
        .get<{ entries: AuditLogEntry[] }>(`/companies/${companyId}/audit-log`, Object.keys(params).length ? params : undefined)
        .then((r) => r.entries);
    },
  });
}
